import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_DispatchLaborBus } from '@app/cp/shared/models/v_DispatchLaborBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';

@Component({
  selector: 'jobs-labor',
  templateUrl: './jobs-labor.component.html',
  styleUrls: ['./jobs-labor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JobsLaborComponent extends BaseGridUIComponent<v_DispatchLaborBus, null, DispatchesService>  {

    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
    }
}
